<template>
  <div class="qrcode-container">
    <canvas ref="qrcodeCanvas"></canvas>
  </div>
</template>

<script>
import QRCode from "qrcode";

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 200,
    },
    darkColor: {
      type: String,
      default: "#000000",
    },
    lightColor: {
      type: String,
      default: "#ffffff",
    },
  },
  watch: {
    text: "generateQR",
    size: "generateQR",
    darkColor: "generateQR",
    lightColor: "generateQR",
  },
  mounted() {
    this.generateQR();
  },
  methods: {
    async generateQR() {
      if (!this.text) return;

      try {
        await QRCode.toCanvas(this.$refs.qrcodeCanvas, this.text, {
          width: this.size,
          margin: 2,
          color: {
            dark: this.darkColor,
            light: this.lightColor,
          },
        });
      } catch (err) {
        console.error("二维码生成失败:", err);
      }
    },
  },
};
</script>
